export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-4.ae376bab.png";